// extracted by mini-css-extract-plugin
module.exports = {"skuContainer":"SkusList_skuContainer_1KZJI"};